import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { LicenseInfo } from "@mui/x-license-pro";
import { PersistGate } from "redux-persist/integration/react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./backend/graphql";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { ConfirmProvider } from "material-ui-confirm";

LicenseInfo.setLicenseKey(
  "30d1a7c275c877ebbe105d5890f675c5Tz0xMjQ4NjMsRT0xODAxNTI2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y",
);

loadDevMessages();
loadErrorMessages();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={client}>
          <ConfirmProvider
            defaultOptions={{
              confirmationButtonProps: { autoFocus: true },
            }}
          >
            <App />
          </ConfirmProvider>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
